import React, { useEffect, useRef, useState } from 'react';
import $ from 'jquery';
import 'datatables.net-dt';
import 'datatables.net-responsive-dt';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import 'datatables.net-responsive-dt/css/responsive.dataTables.css';
import axios from "axios";
import { Get, GetList, GetTime } from '../lib/DeviceData';
import moment from 'moment';

const HistoryLog = (props) => {
  const tableRef = useRef(null);
  const dataTableRef = useRef(null);
  const [result_data, setDatas] = useState([]);

  useEffect(()=> {
    fetchData();
  }, [props.data]);

  const fetchData = () => {
      try {
        const data = props.data;

        
        const device_no=data.device_no;
        const date = data.date;
        const time = data.time;
        const start_date=moment(date+" "+time+":00:00").utc().format("YYYY-MM-DD HH:mm:ss");
        const end_date=moment(date+" "+time+":59:59").utc().format("YYYY-MM-DD HH:mm:ss");

        if(time){
            GetTime(device_no, start_date,end_date, res => {
                setDatas(res);
            });
            
            console.log(result_data);
        }
        
      } catch (error) {
        console.log("Error fetching data:", error);
      }
  };


  // datatable 초기화 중복 경고 메시지를 방지
  useEffect(() => {
    if (dataTableRef.current === null) {
      $(tableRef.current).DataTable({
        paging: false,
        pageLength: 60,
      });
      dataTableRef.current = true;
    }
  }, []);
  

  useEffect(() => {
    // pageLength: 페이지에 보여줄 row 갯수 설정
    // columns: 데이터 key값을 넣으면 됩니다.
    if (dataTableRef.current) {
      $(tableRef.current).DataTable().destroy();
      $(tableRef.current).DataTable({
        data: result_data.rows,
        columns: [
          { data: 'bucket' },
          { data: 'hr' },
          { data: 'rr' },
          { data: 'apnea' },
          { data: 'motion' },
        ],
        columnDefs: [{
            targets: 0, //index of column
            render:function(data, type, row){
                return moment(data).format('YYYY-MM-DD hh:mm:ss'); }
            },
        ],
        paging: false,
        pageLength: 60,
        destroy: true,
        responsive: true,
        ordering: false,
        searching: false,
        scrollCollapse: true,
        scrollY: '30vh',
        info:false,
      });
    }

  }, [result_data]);

  return (
    <div>
      <table ref={tableRef} className='table stripe row-border table-stripe cell-border' style={{ width: '100%' }}>
        <thead>
          <tr>
            <th>Time(min)</th>
            <th>HR(bpm)</th>
            <th>RR(bpm)</th>
            <th>Motion</th>
            <th>Apnea</th>
          </tr>
        </thead>
        <tbody></tbody>
      </table>
    </div>
  );
};

export default HistoryLog;